import { render, staticRenderFns } from "./DeliveryModal.vue?vue&type=template&id=7b0c5797&scoped=true&lang=pug&"
import script from "./DeliveryModal.vue?vue&type=script&lang=js&"
export * from "./DeliveryModal.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryModal.vue?vue&type=style&index=0&id=7b0c5797&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0c5797",
  null
  
)

export default component.exports